import api from '../../../services/api'
import { TrainingWorkoutTypeEnum } from '../../../components/TrainingWorkout'
import {
  addTrainingWorkoutInGroupRequest,
  addTrainingWorkoutRequest,
  addSubstituteTrainingWorkoutRequest,
  removeSubstituteTrainingWorkoutRequest,
  updateSubstituteSetupRequest,
  editTypeGroupTrainingWorkoutRequest,
  GeneralResponse, getTrainingWorkoutDataRequest,
  removeTrainingWorkoutFromGroupRequest, reorderGroupTrainingWorkoutRequest, reorderTrainingWorkoutRequest,
  saveCombineRequest, updateGroupTrainingWorkoutSetupRequest,
  updateTrainingWorkoutSetupRequest
} from './training-workout-service.interfaces'
import { getInitialURL, getUngroupURL } from '../../../components/TrainingWorkout/functions'

const getTrainingWorkoutList = async ({ trainingId, type }: getTrainingWorkoutDataRequest): Promise<GeneralResponse> => {
  const response = await api.get(getInitialURL(trainingId, type))
  return {
    status: response?.status,
    data: response?.data
  }
}

const addTrainingWorkout = async ({ payload, type }: addTrainingWorkoutRequest): Promise<GeneralResponse> => {
  let response
  if (type === TrainingWorkoutTypeEnum.ATHLETE) {
    response = await api.post('professional-athlete-training-workouts', {
      professionalAthleteTrainingId: payload.trainingId,
      workoutId: payload.workoutId
    })
  }
  if (type === TrainingWorkoutTypeEnum.TRAINING_BENCH) {
    response = await api.post('training-workouts', payload)
  }
  return {
    status: response?.status,
    data: response?.data
  }
}

const addTrainingWorkoutInGroup = async ({ groupTrainingWorkoutId, payload, type }: addTrainingWorkoutInGroupRequest): Promise<GeneralResponse> => {
  let response
  if (type === TrainingWorkoutTypeEnum.ATHLETE) {
    response = await api.put(
      `/professional-athlete-training-workouts/professional-athlete-group-training-workouts/${groupTrainingWorkoutId}/addGroup`
      , {
        professionalAthleteTrainingWorkoutId: payload.trainingWorkoutId
      })
  }
  if (type === TrainingWorkoutTypeEnum.TRAINING_BENCH) {
    response = await api.put(`/training-workouts/group-training-workouts/${groupTrainingWorkoutId}/addGroup`, payload)
  }
  return {
    status: response?.status,
    data: response?.data
  }
}

const updateTypeGroupTrainingWorkout = async ({ groupTrainingWorkoutId, type, payload }: editTypeGroupTrainingWorkoutRequest): Promise<GeneralResponse> => {
  let response
  if (type === TrainingWorkoutTypeEnum.ATHLETE) {
    response = await api.put(
      `/professional-athlete-group-training-workouts/${groupTrainingWorkoutId}/change-type`,
      payload
    )
  }
  if (type === TrainingWorkoutTypeEnum.TRAINING_BENCH) {
    response = await api.put(`/group-training-workouts/${groupTrainingWorkoutId}/change-type`, payload)
  }
  return {
    status: response?.status,
    data: response?.data
  }
}

const reorderGroupTrainingWorkout = async ({ trainingWorkoutGroupId, payload, type }: reorderGroupTrainingWorkoutRequest): Promise<any> => {
  if (type === TrainingWorkoutTypeEnum.ATHLETE) {
    await api.put(`/professional-athlete-group-training-workouts/${trainingWorkoutGroupId}/reorder`, {
      professionalAthleteTrainingWorkoutId: payload?.trainingWorkoutId,
      newSort: payload.newSort
    })
  }
  if (type === TrainingWorkoutTypeEnum.TRAINING_BENCH) {
    await api.put(`/group-training-workouts/${trainingWorkoutGroupId}/reorder`, payload)
  }
}

const reorderTrainingWorkout = async ({ trainingId, payload, type }: reorderTrainingWorkoutRequest): Promise<any> => {
  if (type === TrainingWorkoutTypeEnum.ATHLETE) {
    await api.put(`professional-athlete-trainings/${trainingId}/reorder`, {
      professionalAthleteTrainingWorkoutId: payload?.trainingWorkoutId,
      professionalAthleteGroupTrainingWorkoutId: payload?.groupTrainingWorkoutId,
      newSort: payload.newSort
    })
  }
  if (type === TrainingWorkoutTypeEnum.TRAINING_BENCH) {
    await api.put(`/trainings/${trainingId}/reorder`, payload)
  }
}

const combineTrainingWorkout = async ({ payload, type }: saveCombineRequest): Promise<GeneralResponse> => {
  let response
  if (type === TrainingWorkoutTypeEnum.ATHLETE) {
    response = await api.post('professional-athlete-group-training-workouts', {
      type: payload?.type,
      professionalAthleteTrainingWorkoutIds: payload?.trainingWorkoutIds
    })
  }
  if (type === TrainingWorkoutTypeEnum.TRAINING_BENCH) {
    response = await api.post('group-training-workouts', payload)
  }
  return {
    status: response?.status,
    data: response?.data
  }
}

const updateSetupTrainingWorkout = async ({ trainingWorkoutId, payload, type }: updateTrainingWorkoutSetupRequest): Promise<any> => {
  if (type === TrainingWorkoutTypeEnum.ATHLETE) {
    await api.put(`professional-athlete-training-workouts/${trainingWorkoutId}`, payload)
  }
  if (type === TrainingWorkoutTypeEnum.TRAINING_BENCH) {
    await api.put(`training-workouts/${trainingWorkoutId}`, payload)
  }
}

const updateSetupGroupTrainingWorkout = async ({ groupTrainingWorkoutId, payload, type }: updateGroupTrainingWorkoutSetupRequest): Promise<any> => {
  if (type === TrainingWorkoutTypeEnum.ATHLETE) {
    await api.put(`professional-athlete-group-training-workouts/${groupTrainingWorkoutId}`, payload)
  }
  if (type === TrainingWorkoutTypeEnum.TRAINING_BENCH) {
    await api.put(`group-training-workouts/${groupTrainingWorkoutId}`, payload)
  }
}

const removeTrainingWorkoutFromGroup = async ({ trainingWorkoutId, type }: removeTrainingWorkoutFromGroupRequest): Promise<GeneralResponse> => {
  const response = await api.post(getUngroupURL(trainingWorkoutId, type))
  return {
    status: response?.status,
    data: response?.data
  }
}

const addSubstituteTrainingWorkout = async ({
  payload,
  type
}: addSubstituteTrainingWorkoutRequest): Promise<GeneralResponse> => {
  let response
  if (type === TrainingWorkoutTypeEnum.ATHLETE) {
    response = await api.post('professional-athlete-training-workouts', {
      professionalAthleteTrainingId: payload.trainingId,
      workoutId: payload.workoutId,
      parentProfessionalAthleteTrainingWorkoutId: payload.parentTrainingWorkoutId
    })
  }
  if (type === TrainingWorkoutTypeEnum.TRAINING_BENCH) {
    response = await api.post('training-workouts', {
      trainingId: payload.trainingId,
      workoutId: payload.workoutId,
      parentTrainingWorkoutId: payload.parentTrainingWorkoutId
    })
  }
  return {
    status: response?.status,
    data: response?.data
  }
}

const removeSubstituteTrainingWorkout = async ({
  trainingWorkoutId,
  type
}: removeSubstituteTrainingWorkoutRequest): Promise<GeneralResponse> => {
  let response
  if (type === TrainingWorkoutTypeEnum.ATHLETE) {
    response = await api.delete(`professional-athlete-training-workouts/${trainingWorkoutId}`)
  }
  if (type === TrainingWorkoutTypeEnum.TRAINING_BENCH) {
    response = await api.delete(`training-workouts/${trainingWorkoutId}`)
  }
  return {
    status: response?.status,
    data: response?.data
  }
}

const updateSubstituteSetup = async ({
  trainingWorkoutId,
  payload,
  type
}: updateSubstituteSetupRequest): Promise<any> => {
  if (type === TrainingWorkoutTypeEnum.ATHLETE) {
    await api.put(`professional-athlete-training-workouts/${trainingWorkoutId}`, payload)
  }
  if (type === TrainingWorkoutTypeEnum.TRAINING_BENCH) {
    await api.put(`training-workouts/${trainingWorkoutId}`, payload)
  }
}

export const TrainingWorkoutService = {
  addTrainingWorkout,
  removeTrainingWorkoutFromGroup,
  updateSetupTrainingWorkout,
  combineTrainingWorkout,
  updateSetupGroupTrainingWorkout,
  reorderGroupTrainingWorkout,
  reorderTrainingWorkout,
  addTrainingWorkoutInGroup,
  getTrainingWorkoutList,
  updateTypeGroupTrainingWorkout,
  addSubstituteTrainingWorkout,
  removeSubstituteTrainingWorkout,
  updateSubstituteSetup
}
